import { useTranslation } from 'react-i18next';

import type { User } from '../../../types';
import getFullName from '../../../utils/getFullName';
import { UserAvatar, UserChip } from '../../base';
import { AutocompleteMultipleField, type AutocompleteMultipleFieldProps } from '../../fields/AutocompleteMultipleField';
import type { FormIncidentsFilter } from '../lib/types';

export type RegisteredByFieldProps = Omit<
  AutocompleteMultipleFieldProps<FormIncidentsFilter, 'registeredBy', User>,
  'name' | 'label' | 'getOptionLabel' | 'renderTags' | 'renderOption'
>;

export const RegisteredByField = (props: RegisteredByFieldProps) => {
  const { t } = useTranslation();

  return (
    <AutocompleteMultipleField
      {...props}
      name='registeredBy'
      getOptionLabel={(user) => getFullName(user)}
      renderTags={(value, getTagProps) =>
        value.map((user, index) => <UserChip user={user} variant='outlined' size='small' {...getTagProps({ index })} />)
      }
      label={t('registered-by')}
      renderOption={(liProps, user) => (
        <li {...liProps}>
          <UserAvatar user={user} sx={{ marginRight: '8px' }} />
          {getFullName(user)}
        </li>
      )}
    />
  );
};
